import React from 'react';

// Icons
import FacilityIcon from '@material-ui/icons/Business';
import UserIcon from '@material-ui/icons/AssignmentInd';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import GroupIcon from '@material-ui/icons/BusinessCenter';
import ReportsIcon from '@material-ui/icons/PieChart';
import MailIcon from '@material-ui/icons/Mail';

import MenuNavItems from './menuNavItems';
import MenuNavBtns from './menuNavBtns';
import * as MS from './menu.styles';

export interface MenuNavProps {
  isCollapsed: boolean;
}

const MenuNav = (props: MenuNavProps) => {
  const { isCollapsed } = props;
  let items = [];

  items.push({
    name: 'Visitor Information',
    link: '/visitor-information',
    Icon: FacilityIcon,
  });
  items.push({
    name: 'Users',
    link: '/users',
    Icon: UserIcon,
  });
  items.push({
    name: 'Group Visits',
    link: '/group-visits',
    Icon: GroupIcon,
  });
  items.push({
    name: 'Exhibits',
    link: '/exhibits',
    Icon: AssignmentOutlinedIcon,
  });
  items.push({
    name: 'Reports',
    link: '/reports',
    Icon: ReportsIcon,
  });
  items.push({
    name: 'Notifications',
    link: '/notifications',
    Icon: MailIcon,
  });

  return (
    <div
      data-cy='sidebar_container'
      data-iscollapsed={isCollapsed}
      id='sidebar'
    >
      <MS.NavList disablePadding>
        {!isCollapsed && (
          <MS.NavListHeader disableSticky={true}></MS.NavListHeader>
        )}
        <MenuNavItems isCollapsed={isCollapsed} items={items} />
      </MS.NavList>
      <MenuNavBtns isCollapsed={isCollapsed} />
    </div>
  );
};

export default MenuNav;
